import api from './api';

export const fetchCompositionGradeService = (id: string) =>
  api(`/api/v1/composition_grades/${id}/`);

export const saveCompositionGradeService = (request: {body: any; id: string}) =>
  api(`/api/v1/composition_grades/${request.id}`, {
    data: request.body,
  });
